var filter = (function(){
    var serverImgUrl=function(imgSrc,cropSize,type) {
        var type = (type=='avatar')?'avatar':'images';
        if(!imgSrc){
            return '';
        }
        var cropSizeStr='';
        if(cropSize){
            cropSizeStr='_'+cropSize.split('x')[0];
        }
        var urlPointIndex=imgSrc.lastIndexOf('.');
        var urlArr=[imgSrc.substr(0,urlPointIndex),imgSrc.substr(urlPointIndex)];
        var urlBefore='';
        if(imgSrc.indexOf('http')!==0){
            urlBefore='/upload/'+type+'/';
        }else{
            console.warn('serverImgUrl_filter:some image url string has http head',imgSrc);
        }
        if(cropSizeStr!=='' && urlArr[0].lastIndexOf(cropSizeStr)===urlArr[0].length-cropSizeStr.length){
            cropSizeStr='';
            console.warn('serverImgUrl_filter:some image url string has crop info',imgSrc);
        }
        return urlBefore+urlArr[0]+cropSizeStr+urlArr[1];
    }
    return serverImgUrl
})()

export default filter;